import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-confirm-box',
  templateUrl: './confirm-box.component.html',
  styleUrls: ['./confirm-box.component.scss'],
})

export class ConfirmBoxComponent implements OnInit {
  @Output() updateInfo = new EventEmitter<object>();
  constructor() {}

  ngOnInit(): void {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result:any) => {
      let statusType: number = 0;
      if (result.isConfirmed) {
        statusType = 1;
      }
      this.updateInfo.emit({ type: statusType });
    });
  }
}
